/**
 * 解码 apiBase（可能被双重 encodeURIComponent，或 session 里存了编码串）
 */
export function decodeApiBaseParam(value) {
  if (!value) return '';
  let s = String(value).trim();
  for (let i = 0; i < 4; i++) {
    if (!/%[0-9A-Fa-f]{2}/.test(s)) {
      break;
    }
    try {
      const decoded = decodeURIComponent(s);
      if (decoded === s) {
        break;
      }
      s = decoded;
    } catch (_) {
      break;
    }
  }
  return s;
}
